import { pushCellHistory } from "../pushCellHistory";
import { snapCells } from "../snapCells";
import { sortCells } from "../sortCells";
import { Cell, CELL_THRESHOLD, State } from "../types";

export type AddRowAction = Readonly<{
  type: "ADD ROW";
  y: number;
}>;

export const addRow = (state: State, action: AddRowAction): State => {
  const cells = state.cells.reduce((prev, next) => {
    if (action.y <= next.minY || action.y >= next.maxY) {
      prev.push(next);
      return prev;
    }
    const newTopCell = {
      ...next,
      maxY: action.y,
    };
    const newBottomCell = {
      ...next,
      minY: action.y,
      selected:false
    };
    if (
      newTopCell.maxY - newTopCell.minY >= CELL_THRESHOLD &&
      newBottomCell.maxY - newBottomCell.minY >= CELL_THRESHOLD
    ) {
      prev.push(newTopCell);
      prev.push(newBottomCell);
    } else {
      prev.push(next);
    }
    return prev;
  }, [] as Array<Cell>);
  if (cells.length === state.cells.length) {
    return {
      ...state,
      mouseDragStart: null,
      mousePosition: null,
      showTableUI: true,
    };
  }
  return pushCellHistory(
    state,
    sortCells(snapCells(cells, state.zoneWidth, state.zoneHeight, CELL_THRESHOLD)),
    {
      mouseDragStart: null,
      mousePosition: null,
      showTableUI: true,
    },
  );
};
